// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.e49b0ceb',
  revision: 'e49b0ceb',
  branch: 'develop',
  date: 'Fri, 17 Apr 2026 12:48:53 GMT'
};